import script from "./CLobbyStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./CLobbyStatus.vue?vue&type=script&setup=true&lang=ts"

import "./CLobbyStatus.vue?vue&type=style&index=0&id=1be64de0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be64de0"]])

export default __exports__